import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import turkishToEnglish from "../../../constants/turkishToEnglish";

const PaymentStatusFilter = ({
    value,
    onChange,
    disabled = false,
    showAllOption = true,
    allowClear = true,
    hideTitle = false,
    marginBottom = "20px",
    placeholder = "Ödeme Durumu",
    ...props
}) => {
    const {t} = useTranslation(["common"]);
    const stores = useStore();

    const [statusNamesLoading, statusNames] = useFetch({
        fetchFn: stores.courierWithdrawRequestStore.statusNames.bind(null, {}),
        initialCall: true
    });

    return (
        <React.Fragment>
            {!hideTitle && <h5>Ödeme Durumu</h5>}
            <SelectField
                data-testid="paymentStatusSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                showSearch
                filterOption={(input, option) => {
                    if (!input || !option || !option.children) return false;

                    const searchInput = input.toLocaleLowerCase("tr");
                    const optionText = String(option.children).toLocaleLowerCase("tr");

                    return (
                        optionText.includes(searchInput) ||
                        turkishToEnglish(optionText).includes(turkishToEnglish(searchInput))
                    );
                }}
                allowClear={allowClear}
                mb={marginBottom}
                placeholder={placeholder}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="paymentStatusSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {statusNames?.map(status => (
                    <SelectField.Option
                        key={status.value}
                        value={status.value}
                        data-testid="paymentStatusSelect_option"
                    >
                        {status.label}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default PaymentStatusFilter;
